import * as saleProductAction from './sale-product'

export {
  saleProductAction,
}



// WEBPACK FOOTER //
// ./src/actions/sale-product/index.js